class RetryService {
  #resolve = null;
  #reject = null;
  #config = null;

  register({ resolve, reject, config }) {
    this.#resolve = resolve;
    this.#reject = reject;
    this.#config = config;
  }

  get() {
    const result = {
      resolve: this.#resolve,
      reject: this.#reject,
      config: this.#config,
    };
    return result;
  }

  cancel() {
    this.#resolve = null;
    this.#reject = null;
    this.#config = null;
  }
}

export default new RetryService();
